export default {
  nav: {
    findBarber: 'Pronađi barbera'
  },
  navigation: {
    home: 'Početna',
    aboutUs: 'O nama',
    contactUs: 'Kontakt',
    demo: 'Demo',
    login: 'Prijava',
    language: 'Jezik',
    logo: 'Logo',
    toggleMenu: 'Otvori/zatvori izbornik',
    changeLanguage: 'Promijeni jezik',
    scrollToTop: 'Na vrh',
    joinAsBarber: 'Pridruži se kao barber',
    pricing: 'Cjenik',
    signUp: 'Prijava / Registracija'
  },
  home: {
    hero: {
      eyebrow: 'Sada primamo u Sofiji - ostala su samo 3 mjesta ovaj tjedan',
      mainTitle: 'Tvoj stolac.<br>Tvoj raspored.<br><span class="hero-title-accent">Tvoj rast.</span>',
      mainDesc: "Godinama usavršavaš svoj zanat. Ne bi trebao provoditi večeri odgovarajući na WhatsApp poruke. Barbers Unity ti daje profesionalnu stranicu za rezervacije i potpuni kalendar - tako da se možeš fokusirati na šišanje, a ne na lovljenje klijenata.",
      growBusiness: 'Želim više klijenata',
      seeDashboard: 'Pogledaj nadzornu ploču',
      trustText: '<strong>Petar Barbov</strong> i barberi diljem Europe već su na platformi.',
      joinThem: 'Pridruži im se →'
    },
    pain: {
      label: 'Zvuči li ti ovo poznato?',
      answer: 'Barbers Unity rješava sve to.',
      items: [
        'Klijenti te zovu baš kad si usred šišanja',
        'Nedolasci (no-shows) koji ti troše najbolje termine',
        'Zaboravljaš potvrditi WhatsApp rezervacije',
        'Duple rezervacije zbog kojih ti je neugodno',
        'Korištenje papirnatog rokovnika u 2025. godini'
      ]
    },
    mobile: {
      label: 'Upravljanje iz džepa',
      title: 'Upravljaj svojim salonom s bilo kojeg mjesta.',
      desc: "Ne radiš za radnim stolom. Barbers Unity je u potpunosti optimiziran za tvoj mobitel. Provjeri svoj raspored, prihvati rezervacije i pregledaj povijest klijenata između šišanja.",
      list: [
        'Trenutne push obavijesti za nove rezervacije',
        'Cjelokupna povijest klijenta na jedan pogled',
        'Dodaj klijente bez najave u kalendar u samo 3 sekunde'
      ]
    },
    featuresList: [
      { title: 'Tvoja vlastita stranica za rezervacije', desc: 'Profesionalni link koji možeš podijeliti bilo gdje - Instagram bio, WhatsApp, Google. Klijenti se sami naručuju, 24/7.' },
      { title: 'Pametni kalendar', desc: 'Pregledaj cijeli tjedan u jednom pogledu. Blokiraj privatno vrijeme, postavi radno vrijeme i nikad više nemoj imati duple rezervacije.' },
      { title: 'Baza klijenata', desc: "Povijest i kontakt podaci svakog klijenta - organizirani, pretraživi i uvijek pri ruci." },
      { title: 'Međunarodna platforma', desc: 'Izrađena za barbere diljem Europe. Podržava EN, BG, HR, ALB, GER i nastavlja rasti.' }
    ],
    calendar_preview: {
      title: 'Tvoj kalendar, na svakom uređaju.'
    },
    how: {
      label: 'Kako početi',
      title: 'Spreman za rad u manje od 10 minuta'
    },
    stepsList: [
      { title: 'Izradi svoj profil', desc: 'Prijavi se za par minuta. Dodaj svoje usluge, postavi radno vrijeme i odmah dobij svoj profesionalni link za rezervacije. Nisu potrebne tehničke vještine.' },
      { title: 'Podijeli svoj link za rezervacije', desc: 'Stavi ga u svoj Instagram bio, WhatsApp status ili ga pošalji stalnim klijentima. Naručuju se u par sekundi.' },
      { title: 'Samo dođi i šišaj', desc: 'Kalendar upravlja sam sobom. Ti se samo fokusiraj na šišanje i izgradnju svog imena.' }
    ],
    trust: {
      card1: { title: 'Mi odrađujemo teži dio posla', desc: "Bojiš se promjene sustava? Nemoj. Pošalji nam svoju listu klijenata (Excel, izvoz iz Booksyja ili slike starog rokovnika) i mi ćemo uvesti tvoje klijente i besplatno izraditi tvoj profil." },
      card2: { title: '100% vlasništvo nad podacima', desc: 'Druge platforme koriste tvoje klijente kako bi promovirale konkurentske barbere. S Barbers Unityjem, tvoja lista klijenata je isključivo tvoja. Nikada ne prodajemo tvoje podatke niti šaljemo reklame tvojim klijentima.' }
    },
    testimonial: {
      quote: "Prije Barbers Unityja gubio sam 3-4 termina tjedno samo na propuštene pozive i WhatsApp poruke na koje sam zaboravio odgovoriti. S 20 € po šišanju, to je 240-320 € koje sam gubio svaki mjesec. Sada se moj kalendar sam puni. Ja samo dođem i šišam.",
      name: 'Petar Barbov',
      role: 'Profesionalni barber · Rani član'
    },
    stats: {
      label: 'Aktivnost platforme',
      title: 'Stvarne brojke koje rastu svaki dan',
      bookings: 'Upravljane rezervacije',
      clients: 'Usluženi klijenti',
      time: 'Ušteđeno administrativno vrijeme po barberu / tjedno'
    },
    pricing: {
      label: 'Poštene cijene',
      title: "Ne plaćaj provizije na vlastiti uspjeh",
      desc: 'Druge te platforme kažnjavaju kada imaš više posla tako što naplaćuju po rezervaciji. Mi vjerujemo da ono što zaradiš trebaš zadržati.',
      competitorNote: 'Kada konkurentski barber u tvom gradu zauzme svoje mjesto, on dobiva prednost. Prvi barber u regiji dobiva prioritetno mjesto pri pretraživanju klijenata.',
      identityLine: 'Izrađeno za barbere koji ovo tretiraju kao posao, a ne kao hobi.',
      them: {
        label: 'Konkurencija',
        list: [ 'Naplata po rezervaciji', 'Skrivene naknade i neočekivani troškovi', 'Troškovi rastu kada imaš više posla' ],
        price: 'Do 200 €',
        sub: '/mj'
      },
      vs: 'VS',
      us: {
        label: 'Barbers Unity',
        list: [ 'Neograničene rezervacije', 'Nula provizija, bez skrivenih naknada', 'Zadrži 100% svojih prihoda' ],
        price: '35 €',
        sub: '/mj fiksno'
      }
    },
    calc: {
      label: 'Kalkulator prihoda',
      title: "Pogledaj koliko gubiš",
      desc: 'Svaki propušteni termin znači manje novca. Pomiči klizače da vidiš koliko bi više mogao zaraditi svaki mjesec.',
      button: 'Počni zarađivati više',
      cuts: 'Šišanja dnevno',
      price: 'Cijena po šišanju (€)',
      missed: 'Propušteni termini tjedno',
      monthlyNow: 'Tvoj mjesečni prihod sada',
      withUs: 'S Barbers Unityjem',
      recovered: '/ mjesečno vraćeno',
      lossThisMonth: 'već izgubljeno ovaj mjesec'
    },
    faq: {
      label: 'Imaš pitanja?',
      title: 'Često postavljana pitanja'
    },
    faqList: [
      { q: "Moraju li moji klijenti skinuti aplikaciju?", a: "Ne! Tvoji klijenti rezerviraju putem čistog i brzog linka direktno iz svog preglednika. Nema preuzimanja aplikacija, nema obaveznih računa i nema komplikacija za njih." },
      { q: "Kako dobivam novac?", a: "Zadržavaš 100% onoga što zaradiš. Klijenti ti plaćaju direktno u salonu kao i uvijek. Mi ne uzimamo nikakav postotak ni proviziju od tvog rada." },
      { q: "Jesam li vezan ugovorom?", a: "Apsolutno ne. Barbers Unity je fiksna mjesečna pretplata. Slobodan si otkazati u bilo kojem trenutku." },
      { q: "Već koristim drugi sustav. Je li teško prebaciti se?", a: "Zahtijeva 0 truda s tvoje strane. Pošalji nam svoju trenutnu listu klijenata, a mi ćemo uvesti sve i izraditi tvoj profil potpuno besplatno." }
    ],
    upcoming: {
      label: 'Uskoro',
      title: 'Stižu još moćniji alati',
      badge: 'Uskoro'
    },
    upcomingList: [
      { title: 'Automatski podsjetnici', desc: 'Email i WhatsApp podsjetnici koji se šalju prije svakog termina - nedolasci postaju stvar prošlosti.' },
      { title: 'Analitika i pregled prihoda', desc: 'Pogledaj svoje najbolje usluge, najprometnije sate i top klijente - donosi pametnije odluke za svoj posao.' },
      { title: 'Sustav lojalnosti', desc: 'Nagradi stalne klijente, prati njihove dolaske i potakni ih da se vraćaju pomoću našeg ugrađenog sustava.' }
    ],
    cta: {
      eyebrow: 'Ograničena mjesta - rezerviraj prije nego što se popune',
      title: 'Spreman napuniti svoj kalendar?',
      sub: 'Pridruži se barberima koji sami upravljaju svojim poslom - a ne obrnuto.',
      microYes: [
        'Želim pun kalendar svaki tjedan',
        'Želim nula nedolazaka',
        'Ne želim više glumiti recepcionara'
      ],
      findBarber: 'Pronađi barbera u svojoj blizini',
      member: 'Već si član?',
      login: 'Prijavi se na nadzornu ploču →'
    },
    pricingCta: {
      title: 'Spreman za rast svog salona?',
      subtitle: '35 €/mj · Prvi mjesec besplatno',
      button: 'Započni sada'
    }
  },
  about: {
    title: 'O Barbers Unityju',
    description: "Iz korijena mijenjamo način na koji se barberi povezuju sa svojim klijentima. Naša platforma pomaže barberima da pokažu svoj rad, upravljaju rasporedima i učinkovito razvijaju svoje poslovanje.",
    founded: 'Osnovan 2025. godine, Barbers Unity izrastao je iz jednostavne ideje u cjelovitu platformu koja služi barberima u više država.',
    ourStory: 'Naša priča',
    whatDrivesUs: 'Što nas pokreće',
    mission: {
      title: 'Naša misija',
      description: 'Pojednostaviti i modernizirati proces rezervacija za barbere'
    },
    vision: {
      title: 'Naša vizija',
      description: 'Stvoriti najveću zajednicu povezanih barbera diljem svijeta'
    },
    values: {
      title: 'Naše vrijednosti',
      description: 'Kvaliteta, povjerenje i profesionalni rast'
    },
    built: {
      label: 'Izrađeno za struku',
      title: 'Znamo kako je to biti iza stolca.',
      desc1: "Barbers Unity nije nastao u korporativnim uredima. Nastao je jer smo vidjeli kako sjajni barberi - talentirani, traženi, poštovani - gube klijente zbog neodgovorenih poziva i loših sustava za rezervacije koji nisu bili namijenjeni njima.",
      desc2: 'Izgradili smo platformu kakvu smo i sami željeli: onu koja tvoj zanat shvaća ozbiljno, stavlja tvoje ime na prvo mjesto i rješava administraciju kako ti ne bi morao brinuti o tome.',
      stats: {
        countries: 'Države u kojima poslujemo',
        time: 'Vrijeme do aktivacije',
        cost: 'Cijena postavljanja'
      }
    },
    testimonial: {
      quote: "Prije Barbers Unityja gubio sam 3-4 termina tjedno samo na propuštene pozive i WhatsApp poruke na koje sam zaboravio odgovoriti. S 20 € po šišanju, to je 240-320 € koje sam gubio svaki mjesec. Sada se moj kalendar sam puni. Ja samo dođem i šišam.",
      name: 'Petar Barbov',
      role: 'Profesionalni barber · Rani član'
    },
    timeline: {
      label: 'Vremenska crta',
      title: 'Gradimo nešto veće.',
      items: [
        { year: '2025', event: 'Osniva se Barbers Unity - ideja rođena iz frustracije zbog beskrajnih poziva i propuštenih termina.' },
        { year: '2025', event: 'Platforma se lansira u Beta verziji.' },
        { year: 'Sada', event: 'Širenje mreže - više barbera, više gradova, bolji alati za sve.' }
      ]
    },
    cta: {
      eyebrow: 'Ograničena mjesta - rezerviraj prije nego što se popune',
      title: 'Želiš biti dio priče?',
      description: "Bilo da si barber ili klijent, za tebe uvijek ima mjesta u Barbers Unity zajednici.",
      findBarber: 'Pronađi barbera',
      getInTouch: 'Kontaktiraj nas'
    }
  },
  contact: {
    title: 'Kontakt',
    getInTouch: {
      title: 'Kontaktiraj nas',
      description: 'Imaš pitanja o Barbers Unityju? Tu smo da ti pomognemo! Javi nam se na bilo kojoj od naših društvenih mreža ili nam pošalji direktnu poruku.',
      info: "Imaš pitanja o Barbers Unityju? Tu smo da ti pomognemo - javi nam se putem bilo kojeg kanala u nastavku."
    },
    followUs: 'Prati nas',
    b2b: {
      text: "<strong>Jesi li barber?</strong> Preskoči obrazac - rezerviraj besplatan 20-minutni poziv i sve ćemo postaviti zajedno.",
      button: 'Rezerviraj besplatan poziv'
    },
    success: {
      title: 'Poruka poslana!',
      desc: "Hvala što si se javio. Odgovorit ćemo ti u najkraćem mogućem roku.",
      button: 'Pošalji novu'
    },
    form: {
      name: 'Ime',
      namePlaceholder: 'Tvoje ime',
      email: 'Email',
      emailPlaceholder: 'tvoj@email.com',
      message: 'Poruka',
      messagePlaceholder: 'Reci nam kako možemo pomoći...',
      send: 'Pošalji poruku'
    }
  },
  forBusiness: {
    hero: {
      eyebrow: 'Ograničena mjesta - sada primamo nove barbere',
      mainTitle: 'Nemoj više voditi posao<br><span class="title-accent">ručno.</span>',
      mainDesc: 'Svaki propušteni poziv je novac koji ti curi kroz prste. Svaki nedolazak troši tvoje dragocjeno vrijeme. Barbers Unity ti nudi profesionalni sustav koji drži tvoj kalendar punim, a tvoje klijente informiranima.',
      bookCall: 'Rezerviraj besplatan poziv za postavljanje',
      seeDashboard: 'Pogledaj nadzornu ploču',
      trust: ['Besplatno postavljanje', 'Bez ugovora', 'Spreman za rad u 10 minuta']
    },
    loss: {
      beforeLabel: 'Bez Barbers Unityja',
      afterLabel: 'S Barbers Unityjem',
      without: [
        'Propuštanje poziva dok šišaš',
        'Nedolasci koji ostavljaju prazne termine',
        'Ručno potvrđivanje svake rezervacije',
        'Neuredni rokovnici ili Excel tablice',
        'Ne znaš koje ti usluge donose najviše profita'
      ],
      with: [
        'Klijenti se sami naručuju online, 24/7',
        'Kalendar se ažurira trenutno, bez truda',
        'Profesionalna nadzorna ploča, uvijek uredna',
        'Potpuna povijest rezervacija i izvješća o uslugama',
        'Radi u više država i na više jezika'
      ]
    },
    features: {
      label: 'Što dobivaš',
      heading: 'Sve što treba profesionalnom barberu',
      items: [
        { title: 'Tvoja profesionalna stranica za rezervacije', desc: 'Čist link s tvojim imenom koji možeš podijeliti bilo gdje - Instagram bio, WhatsApp, Google. Klijenti vide usluge, cijene, slobodne termine i sami rezerviraju. Bez poziva, bez beskonačnog dopisivanja.', badge: 'Spremno u par minuta' },
        { title: 'Potpuni kalendar samo za barbere', desc: 'Blokiraj vrijeme za pauzu, postavi radno vrijeme, upravljaj različitim uslugama s različitim trajanjem. Pregledaj cijeli tjedan u jednom pogledu i nikad nemoj imati duple rezervacije.', badge: null },
        { title: 'Povijest i preferencije klijenata', desc: "Povijest šišanja, kontakt podaci i bilješke za svakog klijenta - sve organizirano. Znaj točno što klijent želi i prije nego što sjedne na stolac.", badge: null },
        { title: 'Automatski podsjetnici (uskoro)', desc: 'Poruke podsjetnika putem Emaila i WhatsAppa slat će se automatski prije svakog termina. Nedolasci će nestati kao problem. Lansiramo uskoro.', badge: 'Uskoro' }
      ]
    },
    why: {
      label: 'Zašto nas barberi biraju',
      heading: 'Tvoj stolac.<br>Tvoja pravila.<br>Tvoj profit.',
      body: 'Barbers Unity stavlja tvoj posao pred klijente koji aktivno traže barbera - bez da ih moraš tražiti, loviti ili se stresirati oko toga.',
      list: [
        'Nula lova na klijente - klijenti dolaze tebi',
        'Postavljeno u 20-minutnom pozivu, potpuno besplatno',
        'Radi savršeno uz tvoj trenutni WhatsApp i email',
        "Bez ugovora - otiđi kada god želiš (ali nećeš imati razloga za to)",
        'Osobna podrška od pravih ljudi, a ne robota'
      ],
      highlights: [
        { title: 'Trenutno postavljanje', desc: "20-minutni poziv. Spreman si za rad prije nego što poklopiš." },
        { title: 'Izrađeno za barbere', desc: 'Dizajnirano zajedno s barberima - ne samo za njih.' },
        { title: 'Više jezika', desc: 'EN, BG, HR, ALB, GER - gdje god radio.' },
        { title: 'Bez ugovora', desc: 'Započni besplatno. Ostani jer funkcionira, a ne zato što moraš.' }
      ]
    },
    testimonial: {
      quote: "Prije Barbers Unityja gubio sam 3-4 termina tjedno samo na propuštene pozive i WhatsApp poruke na koje sam zaboravio odgovoriti. S 20 € po šišanju, to je 240-320 € koje sam gubio svaki mjesec. Sada se moj kalendar sam puni. Ja samo dođem i šišam.",
      name: 'Petar Barbov',
      role: 'Profesionalni barber · Rani član'
    },
    cta: {
      eyebrow: 'Trenutno primamo u Sofiji - ostala su samo 3 mjesta ovaj tjedan',
      mainTitle: 'Spreman za potpuno popunjen raspored?',
      sub: "Rezerviraj besplatan 20-minutni poziv. Sve ćemo postaviti zajedno - tvoj profil, usluge i kalendar. Bit ćeš spreman za rad prije završetka poziva.",
      bookCall: 'Rezerviraj svoj besplatan poziv odmah',
      member: 'Već si član?',
      login: 'Prijavi se na nadzornu ploču →'
    }
  },
  footer: {
    description: 'Povezujemo barbere s njihovim klijentima, pojednostavljujemo rezervacije i razvijamo poslovanja.',
    quickLinks: {
      title: 'Brzi linkovi',
      about: 'O nama',
      contact: 'Kontakt',
      demo: 'Demo'
    },
    legal: {
      title: 'Pravno',
      privacy: 'Politika privatnosti',
      terms: 'Uvjeti korištenja'
    },
    followUs: 'Prati nas',
    social: {
      facebook: 'Facebook',
      instagram: 'Instagram',
      tiktok: 'TikTok'
    },
    copyright: '© 2025 BarbersUnity. Sva prava pridržana.'
  },
  tailwindMessage: "Tailwind CSS radi u Vue 3! 🎉",
  clickMe: "Klikni ovdje",
  previous: 'Natrag',
  notFound: {
    title: 'Stranica nije pronađena',
    description: "Stranica koju tražiš ne postoji ili je premještena.",
    backHome: 'Povratak na početnu'
  },
  cookies: {
    title: 'Postavke kolačića',
    message: 'Koristimo kolačiće kako bismo poboljšali tvoje iskustvo, analizirali promet na stranici i pružili prilagođeni sadržaj. Nastavkom korištenja naše stranice, pristaješ na našu upotrebu kolačića.',
    decline: 'Odbij',
    accept: 'Prihvati sve'
  },
  map: {
    eyebrow: 'Pronađi barbera',
    heading: 'Barberi u tvojoj blizini',
    searchPlaceholder: 'Pretraži po gradu ili imenu barbera...',
    loading: 'Učitavanje karte...',
    error: {
      title: 'Karta se nije uspjela učitati',
      desc: 'Došlo je do problema s učitavanjem karte. Molimo pokušaj ponovno.',
      retry: 'Pokušaj ponovno'
    },
    results: 'rezultata',
    result: 'rezultat',
    bookNow: 'Rezerviraj sada'
  },
  privacy: {
    intro: 'Dobrodošao u Barbers Unity. Poštujemo tvoju privatnost i predani smo zaštiti tvojih osobnih podataka. Ova politika privatnosti informira te o tome kako brinemo o tvojim podacima kada posjetiš našu stranicu, o tvojim pravima na privatnost i o tome kako te zakon štiti.',
    sections: {
      collect: {
        title: '1. Podaci koje prikupljamo',
        desc: 'Možemo prikupljati, koristiti, pohranjivati i prenositi različite vrste osobnih podataka o tebi, koje smo grupirali na sljedeći način:',
        items: [
          '<strong>Podaci o identitetu</strong> uključuju ime, prezime, korisničko ime ili sličan identifikator.',
          '<strong>Kontakt podaci</strong> uključuju adresu e-pošte i brojeve telefona.',
          '<strong>Tehnički podaci</strong> uključuju adresu internetskog protokola (IP), vrstu i verziju preglednika, vremensku zonu i druge tehnologije na uređajima koje koristiš za pristup ovoj stranici.'
        ]
      },
      use: {
        title: '2. Kako koristimo tvoje podatke',
        desc: 'Tvoje osobne podatke koristit ćemo samo kada nam zakon to dopušta. Najčešće ćemo tvoje podatke koristiti u sljedećim okolnostima:',
        items: [
          'Kada moramo izvršiti ugovor koji ćemo uskoro sklopiti ili smo već sklopili s tobom (npr. rezervacija termina).',
          'Kada je to nužno za naše legitimne interese, a tvoji interesi ili temeljna prava ne nadilaze te interese.',
          'Kada moramo poštovati zakonsku obvezu.'
        ]
      },
      contact: {
        title: '3. Kontaktiraj nas',
        desc: 'Ako imaš bilo kakvih pitanja o ovoj politici privatnosti ili našim praksama, slobodno nam se javi putem naših kontakt kanala.'
      }
    }
  },
  pricing: {
    title: 'Jednostavan cjenik',
    subtitle: 'Jedan plan. Sve uključeno. Prvi mjesec besplatno.',
    price: '35',
    period: '/mj',
    trial: 'Prvi mjesec BESPLATNO',
    cta: 'Započni besplatnu probu',
    features: [
      'Neograničene rezervacije',
      'Obavijesti za klijente',
      'QR kod i generator priča',
      'Kalendar za više radnika',
      'Nadzorna ploča s analitikom',
      'Prioritetna podrška'
    ]
  },
  terms: {
    title: 'Uvjeti korištenja',
    intro: 'Dobrodošli na Barbers Unity. Korištenjem naše platforme pristajete na ove uvjete. Molimo vas da ih pažljivo pročitate.',
    sections: {
      account: {
        title: '1. Registracija računa',
        desc: 'Morate navesti točne podatke prilikom kreiranja računa. Odgovorni ste za čuvanje sigurnosti svojih podataka za prijavu.'
      },
      usage: {
        title: '2. Prihvatljivo korištenje',
        desc: 'Pristajete da nećete zloupotrebljavati platformu, ometati njezin normalan rad ili pokušavati joj pristupiti metodom koja nije sučelje koje pružamo.'
      },
      fees: {
        title: '3. Pretplata i naknade',
        desc: 'Naše se usluge naplaćuju na temelju pretplate. Sve naknade su nepovratne osim ako zakon ne nalaže drugačije.'
      },
      liability: {
        title: '4. Ograničenje odgovornosti',
        desc: 'Barbers Unity pruža se "kakav jest". Nećemo biti odgovorni za bilo kakvu neizravnu, slučajnu ili posljedičnu štetu koja proizlazi iz vašeg korištenja platforme.'
      }
    }
  },
  loading: {
    title: 'Učitavanje...',
    message: 'Molimo pričekajte'
  },
  modal: {
    registerTitle: 'Odaberite vrstu računa',
    businessTitle: 'Registracija kao tvrtka',
    businessDesc: 'Salon / Barber',
    customerTitle: 'Registracija kao klijent',
    customerDesc: 'Rezervacija termina'
  }
}